import { lazy } from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

/* =========================
   PUBLIC ROUTES
========================= */
export const publicRoutes = [
  {
    key: 'login',
    path: `${AUTH_PREFIX_PATH}/login`,
    component: lazy(() => import('views/auth-views/authentication/login')),
  },

  {
    key: 'forgot-password',
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: lazy(() => import('views/auth-views/authentication/forgot-password')),
  },
]

/* =========================
   PROTECTED ROUTES
========================= */
export const protectedRoutes = [
  /* ---------- DASHBOARD ---------- */
  {
    key: 'dashboard.default',
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: lazy(() => import('views/app-views/dashboards/default')),
  },

  /* ---------- COURSES ---------- */
  {
    key: 'courses',
    path: `${APP_PREFIX_PATH}/courses`,
    component: lazy(() => import('views/app-views/courses')),
  },
  {
    key: 'course.modules',
    path: `${APP_PREFIX_PATH}/courses/:courseId/modules`,
    component: lazy(() => import('views/app-views/courses/modules')),
  },
  {
    key: 'module.lessons',
    path: `${APP_PREFIX_PATH}/courses/:courseId/modules/:moduleId/lessons`,
    component: lazy(() => import('views/app-views/courses/modules/lessons')),
  },
  {
    key: 'lesson.media',
    path: `${APP_PREFIX_PATH}/courses/:courseId/modules/:moduleId/lessons/:lessonId/media`,
    component: lazy(() => import('views/app-views/courses/modules/lessons/media')),
  },

  /* ---------- COURSE META ---------- */
  {
    key: 'course.categories',
    path: `${APP_PREFIX_PATH}/categories`,
    component: lazy(() => import('views/app-views/categories')),
  },
  {
    key: 'course.levels',
    path: `${APP_PREFIX_PATH}/course-levels`,
    component: lazy(() => import('views/app-views/levels')),
  },
  {
    key: 'course.durations',
    path: `${APP_PREFIX_PATH}/course-durations`,
    component: lazy(() => import('views/app-views/durations')),
  },

  /* ---------- BLOGS ---------- */
  {
    key: 'blogs',
    path: `${APP_PREFIX_PATH}/blogs`,
    component: lazy(() => import('views/app-views/blogs')),
  },
  {
    key: 'blog.categories',
    path: `${APP_PREFIX_PATH}/blog-categories`,
    component: lazy(() => import('views/app-views/blogs/BlogCategories')),
  },
  {
    key: 'blog.tags',
    path: `${APP_PREFIX_PATH}/blog-tags`,
    component: lazy(() => import('views/app-views/blogs/BlogTags')),
  },

  /* ---------- ENQUIRIES ---------- */
  {
    key: 'enquiries',
    path: `${APP_PREFIX_PATH}/enquiries`,
    component: lazy(() => import('views/app-views/enquiries')),
  },
]
